<template>
  <div class="d-flex">
    <form @submit.prevent="submit" class="d-flex flex-column flex-grow-1">
      <v-container>
        <!-------------------------------- BLOC QUALITÉ FOURNISSEUR -------------------------------->
        <v-col cols="12" sm="10" class="pb-0 pl-8 mt-10">
          <v-toolbar color="#0B87BA" flat dense>
            <v-col cols="6" lg="6" xl="2" class="pa-0 font_color text-left">
              NON CONFORMITÉ
            </v-col>
          </v-toolbar>
        </v-col>

        <v-col cols="12" sm="6" class="pb-0 pl-8 mt-5">
          <div class="text-left mb-3">DATE*</div>
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
            light
          >
            <template v-slot:activator="{ on, attrs }">
              <span v-if="mode !== 'visualisation'" class="d-flex calendar-field">
                <v-text-field
                  :value="formatDate"
                  dense
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  single-line
                  light
                  outlined
                  hide-details
                ></v-text-field>
                <img class="ml-5" src="@/assets/calendar.png" />
              </span>
              <div v-if="mode == 'visualisation'" class="text-left font-weight-bold">{{ formatDate }}</div>
            </template>
            <v-date-picker
              v-model="supplierQuality.date"
              no-title
              locale="fr-fr"
              @input="menu = false"
            ></v-date-picker>
          </v-menu>
          <div class="errorMsg" v-if="$v.supplierQuality.date.$error">
            Renseignez la date
          </div>
        </v-col>

        <v-col cols="12" sm="6" class="pb-0 pl-8 mt-5">
          <div class="text-left mb-3">FOURNISSEUR*</div>
          <v-text-field
            v-if="mode !== 'visualisation'"
            maxLength="200"
            single-line
            outlined
            v-model="supplierQuality.supplier"
            dense
            hide-details
          ></v-text-field>
          <div v-if="mode == 'visualisation'" class="text-left font-weight-bold">{{ supplierQuality.supplier }}</div>
          <div class="errorMsg" v-if="$v.supplierQuality.supplier.$error">
            Renseignez le fournisseur
          </div>
        </v-col>

        <v-col cols="12" sm="6" class="pb-0 pl-8 mt-5">
          <div class="text-left mb-3">N° DE NON CONFORMITÉ FTA*</div>
          <v-text-field
            v-if="mode !== 'visualisation'"
            maxLength="100"
            single-line
            outlined
            v-model="supplierQuality.non_compliance_fta_number"
            dense
            hide-details
            disabled
          ></v-text-field>
          <div v-if="mode == 'visualisation'" class="text-left font-weight-bold">{{ supplierQuality.non_compliance_fta_number }}</div>
          <div class="errorMsg" v-if="$v.supplierQuality.non_compliance_fta_number.$error">
            Renseignez le numéro de NC FTA
          </div>
        </v-col>

        <v-col cols="12" sm="6" class="pb-0 pl-8 mt-5">
          <div class="text-left mb-3">CONTACT FOURNISSEUR*</div>
          <v-text-field
            v-if="mode !== 'visualisation'"
            maxLength="100"
            single-line
            outlined
            v-model="supplierQuality.contact"
            dense
            hide-details
          ></v-text-field>
          <div v-if="mode == 'visualisation'" class="text-left font-weight-bold">{{ supplierQuality.contact }}</div>
          <div class="errorMsg" v-if="$v.supplierQuality.contact.$error">
            Renseignez le contact
          </div>
        </v-col>

        <v-col cols="12" sm="6" class="pb-0 pl-8 mt-5">
          <div class="text-left mb-3">EMAIL FOURNISSEUR*</div>
          <v-text-field
            v-if="mode !== 'visualisation'"
            maxLength="100"
            single-line
            outlined
            v-model="supplierQuality.email"
            dense
            hide-details
          ></v-text-field>
          <div v-if="mode == 'visualisation'" class="text-left font-weight-bold">{{ supplierQuality.email }}</div>
          <div class="errorMsg" v-if="$v.supplierQuality.email.$error && $v.supplierQuality.email.required == false">
            Renseignez l'email
          </div>
          <div class="errorMsg" v-if="$v.supplierQuality.email.$error && $v.supplierQuality.email.required == true && $v.supplierQuality.email.email == false">
            Renseignez une adresse email valide
          </div>
        </v-col>

        <v-col cols="12" sm="10" class="pb-0 pl-8 mt-10">
          <AddArticles
            :retour_a_articles="supplierQuality_a_articles"
            :mode="mode"
            title="SELECTIONNER UN ARTICLE"
            :blocFore="true"
          />
        </v-col>

        <v-col cols="12" sm="10" class="pb-0 pl-8 mt-5">
          <div class="text-left mb-3">INDIQUER LE OU LES CODES DE PRODUCTION*</div>
          <v-textarea
            v-if="mode !== 'visualisation'"
            outlined
            v-model="supplierQuality.code_production_comment"
            dense
            hide-details
          ></v-textarea>
          <div v-if="mode == 'visualisation'" class="text-left font-weight-bold">{{ supplierQuality.code_production_comment }}</div>
          <div class="errorMsg" v-if="$v.supplierQuality.code_production_comment.$error">
            Renseignez le(s) code(s) de production
          </div>
        </v-col>

        <v-col cols="12" sm="10" class="pb-0 pl-8 mt-5">
          <div class="text-left mb-3">DESCRIPTION DU PROBLEME RENCONTRÉ*</div>
          <v-textarea
            v-if="mode !== 'visualisation'"
            outlined
            v-model="supplierQuality.description"
            dense
            hide-details
          ></v-textarea>
          <div v-if="mode == 'visualisation'" class="text-left font-weight-bold">{{ supplierQuality.description }}</div>
          <div class="errorMsg" v-if="$v.supplierQuality.description.$error">
            Renseignez la description
          </div>
        </v-col>

        <v-col cols="12" sm="6" class="pb-0 pl-8 mt-5">
          <div class="text-left mb-3">COÛT ESTIMÉ POUR FTA DE LA NC</div>
          <v-text-field
            v-if="mode !== 'visualisation'"
            maxLength="100"
            single-line
            outlined
            v-model="supplierQuality.estimated_cost"
            dense
            hide-details
          ></v-text-field>
          <div v-if="mode == 'visualisation'" class="text-left font-weight-bold">{{ supplierQuality.estimated_cost }}</div>
        </v-col>

        <v-col cols="12" sm="10" class="pb-0 pl-8 mt-5">
          <div class="text-left mb-3">DESCRIPTION DU COÛT ESTIMÉ (MAIN D'OEUVRE, FRAIS DE PORT, FACTURE CLIENT)</div>
          <v-textarea
            v-if="mode !== 'visualisation'"
            outlined
            v-model="supplierQuality.estimated_cost_description"
            dense
            hide-details
          ></v-textarea>
          <div v-if="mode == 'visualisation'" class="text-left font-weight-bold">{{ supplierQuality.estimated_cost_description }}</div>
        </v-col>

        <v-col cols="12" sm="10" class="pb-0 pl-8 mt-10">
          <v-toolbar color="#0B87BA" flat dense>
            <v-col cols="6" lg="6" xl="2" class="pa-0 font_color text-left">
              RETOUR FOURNISSEUR
            </v-col>
          </v-toolbar>
        </v-col>

        <v-col class="pb-0 pl-8 mt-5">
          <div class="text-left mb-2">NC ACCEPTÉE PAR LE FOURNISSEUR</div>
          <div v-if="mode == 'visualisation'" class="text-left mb-2" :class="trueOrFalse(supplierQuality.is_accepted)">
            {{ supplierQuality.is_accepted == true ? "OUI" : "NON" }}
          </div>
          <v-checkbox
            v-if="mode !== 'visualisation'"
            class="mt-n1"
            v-model="supplierQuality.is_accepted"
            hide-details
          ></v-checkbox>
        </v-col>

        <v-col cols="12" sm="10" class="pb-0 pl-8 mt-5">
          <div class="text-left mb-3">EN CAS DE REFUS, EXPLIQUEZ LES RAISONS</div>
          <v-textarea
            v-if="mode !== 'visualisation'"
            outlined
            v-model="supplierQuality.refusal_reason"
            dense
            hide-details
          ></v-textarea>
          <div v-if="mode == 'visualisation'" class="text-left font-weight-bold">{{ supplierQuality.refusal_reason }}</div>
        </v-col>

        <v-col cols="12" sm="6" class="pb-0 pl-8 mt-5">
          <div class="text-left mb-3">N° DE NON CONFORMITÉ FOURNISSEUR</div>
          <v-text-field
            v-if="mode !== 'visualisation'"
            maxLength="100"
            single-line
            outlined
            v-model="supplierQuality.non_compliance_number"
            dense
            hide-details
          ></v-text-field>
          <div v-if="mode == 'visualisation'" class="text-left font-weight-bold">{{ supplierQuality.non_compliance_number }}</div>
        </v-col>

        <v-col class="pb-0 pl-8 mt-5">
          <div class="text-left mb-2">MATÉRIEL À RETOURNER</div>
          <div v-if="mode == 'visualisation'" class="text-left mb-2" :class="trueOrFalse(supplierQuality.need_return)">
            {{ supplierQuality.need_return == true ? "OUI" : "NON" }}
          </div>
          <v-checkbox
            v-if="mode !== 'visualisation'"
            class="mt-n1"
            v-model="supplierQuality.need_return"
            hide-details
          ></v-checkbox>
        </v-col>

      
        <v-col cols="12" sm="6" class="pb-0 pl-8 mt-5">
          <div class="text-left mb-3">CONDITION DE LIVRAISON</div>
          <v-radio-group
            v-if="mode !== 'visualisation'"
            v-model="supplierQuality.delivery_type"
            hide-details
          >
            <v-radio
              label="Enlèvement fournisseur"
              value="enlevement fournisseur"
            ></v-radio>
            <v-radio
              label="Expédition par nos soins"
              value="expedition par nos soins"
            ></v-radio>
          </v-radio-group>
          <div v-if="mode == 'visualisation'" class="text-left font-weight-bold">{{ supplierQuality.delivery_type }}</div>
        </v-col>

        <v-col cols="12" sm="6" class="pb-0 pl-8 mt-5">
          <div class="text-left mb-3">DATE D'EXPÉDITION</div>
          <v-menu
            ref="menuShipping"
            v-model="menuShipping"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
            light
          >
            <template v-slot:activator="{ on, attrs }">
              <span v-if="mode !== 'visualisation'" class="d-flex calendar-field align-center">
                <v-text-field
                  :value="formatShippingDate"
                  dense
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  single-line
                  light
                  outlined
                  hide-details
                ></v-text-field>
                <img class="ml-5" src="@/assets/calendar.png" />
                <v-btn
                  v-if="supplierQuality.shipping_date"
                  @click.stop="clearShippingDate"
                  icon
                  small
                  class="ml-2"
                >
                  <v-icon small>mdi-close</v-icon>
                </v-btn>
              </span>
              <div v-if="mode == 'visualisation'" class="text-left font-weight-bold">{{ formatShippingDate }}</div>
            </template>
            <v-date-picker
              v-model="supplierQuality.shipping_date"
              no-title
              locale="fr-fr"
              @input="menuShipping = false"
            ></v-date-picker>
          </v-menu>
        </v-col>

        <v-col cols="12" sm="6" class="pb-0 pl-8 mt-5">
          <div class="text-left mb-3">INDIQUER TRANSPORTEUR</div>
          <v-text-field
            v-if="mode !== 'visualisation'"
            maxLength="100"
            single-line
            outlined
            v-model="supplierQuality.carrier"
            dense
            hide-details
          ></v-text-field>
          <div v-if="mode == 'visualisation'" class="text-left font-weight-bold">{{ supplierQuality.carrier }}</div>
        </v-col>

        <v-col cols="12" sm="6" class="pb-0 pl-8 mt-5">
          <div class="text-left mb-3">INDIQUER DIMENSIONS ET POIDS DU COLIS</div>
          <v-text-field
            v-if="mode !== 'visualisation'"
            maxLength="100"
            single-line
            outlined
            v-model="supplierQuality.package_detail"
            dense
            hide-details
          ></v-text-field>
          <div v-if="mode == 'visualisation'" class="text-left font-weight-bold">{{ supplierQuality.package_detail }}</div>
        </v-col>

        <v-col cols="12" sm="10" class="pb-0 pl-8 mt-10">
          <v-toolbar color="#0B87BA" flat dense>
            <v-col cols="6" lg="6" xl="2" class="pa-0 font_color text-left">
              NON CONFORMITÉ CLOTURÉE
            </v-col>
          </v-toolbar>
        </v-col>

        <v-col cols="12" sm="6" class="pb-0 pl-8 mt-5">
          <div class="text-left mb-3">STATUT</div>
          <v-select
            v-if="mode !== 'visualisation'"
            :items="statusOptions"
            single-line
            outlined
            v-model="supplierQuality.status"
            dense
            hide-details
          ></v-select>
          <div v-if="mode == 'visualisation'" class="text-left font-weight-bold">{{ supplierQuality.status }}</div>
        </v-col>

        <v-col v-if="mode !== 'visualisation'" cols="12" class="text-center mt-10">
          <v-btn color="#0B87BA" large dark rounded @click="submit">
            {{ mode === 'modification' ? 'MODIFIER' : 'ENREGISTRER' }}
          </v-btn>
        </v-col>
      </v-container>
    </form>
  </div>
</template>

<script>
import moment from "moment";
import { required, email } from "vuelidate/lib/validators";
import AddArticles from "@/components/Clients/AddArticles";

export default {
  props: ["supplierQuality", "supplierQuality_a_articles", "mode"],
  components: {
    AddArticles,
  },
  data() {
    return {
      menu: false,
      menuShipping: false,
      statusOptions: [
        "",
        "Refusée",
        "Materiel reparé",
        "Avoir accepté",
        "Matériel échangé",
      ],
    };
  },
  validations: {
    supplierQuality: {
      date: { required },
      supplier: { required },
      non_compliance_fta_number: { required },
      contact: { required },
      email: { required, email },
      code_production_comment: { required },
      description: { required },
    },
  },
  computed: {
    formatDate() {
      return this.supplierQuality.date
        ? moment(this.supplierQuality.date).format("DD/MM/YYYY")
        : "";
    },
    formatShippingDate() {
      return this.supplierQuality.shipping_date
        ? moment(this.supplierQuality.shipping_date).format("DD/MM/YYYY")
        : "";
    },
  },
  methods: {
    submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$emit("emitSupplierQuality", this.supplierQuality);
      }
    },
    clearShippingDate() {
      this.supplierQuality.shipping_date = null;
    },
    trueOrFalse(value) {
      return value ? "text-success" : "text-error";
    },
  },
};
</script>

<style lang="scss" scoped>
.font_color {
  color: white;
  font-weight: bold;
}

.calendar-field {
  align-items: center;
}

.errorMsg {
  color: red;
  font-size: 12px;
  margin-top: 5px;
}

.text-success {
  color: green;
  font-weight: bold;
}

.text-error {
  color: red;
  font-weight: bold;
}
</style>
